// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"q2-z"};